__webpack_require__.p = "https://presence-staging.infra-socotec.net/";